/* 

document.addEventListener("DOMContentLoaded", function() {
  let hoverTimeouts = new Map();
  
  function initializeHoverMenus() {
    const submenus = document.querySelectorAll(".header__submenu.list-menu");
    submenus.forEach(submenu => {
      submenu.classList.add("lirogo-submenu");
    });
    
    // Apply lirogo-nav-item to main navigation items only
    const mainNavItems = document.querySelectorAll(".header__inline-menu .header__menu-item:not(.header__submenu .header__menu-item)");
    mainNavItems.forEach(item => {
      item.classList.add("lirogo-nav-item");
    });
    
    // Apply lirogo-dropdown-item to dropdown/submenu items
    const dropdownItems = document.querySelectorAll(".header__submenu .header__menu-item");
    dropdownItems.forEach(item => {
      item.classList.add("lirogo-dropdown-item");
    });
    
    // Recursively find nested details elements (but skip first level)
    function addFlyoutClasses(container, isFirstLevel = false) {
      const details = container.querySelectorAll("details");
      details.forEach(detail => {
        const hasSubmenu = detail.querySelector(".header__submenu");
        if (hasSubmenu) {
          // Only add flyout classes to nested levels, NOT first level
          if (!isFirstLevel) {
            detail.classList.add("lirogo-submenu-parent");
            hasSubmenu.classList.add("lirogo-flyout-submenu");
          }
          // Recursively check this submenu for nested details
          addFlyoutClasses(hasSubmenu, false);
        }
      });
    }
    
    // Start from the main navigation - mark as first level
    const mainNav = document.querySelector(".header__inline-menu");
    if (mainNav) {
      addFlyoutClasses(mainNav, true);
    }
    
    setupHoverBehavior();
    setupClosingBehavior();
  }
  
  function setupHoverBehavior() {
    // Flexible selector: Find all details in main nav, then filter out nested ones
    const allDetails = document.querySelectorAll(".header__inline-menu details");
    const firstLevelDetails = Array.from(allDetails).filter(detail => 
      !detail.closest('.header__submenu')
    );
    
    firstLevelDetails.forEach(detail => {
      // MOUSEENTER: Open dropdown
      detail.addEventListener("mouseenter", function() {
        clearTimeout(hoverTimeouts.get(this));
        
        // Close other first-level dropdowns
        firstLevelDetails.forEach(otherDetail => {
          if (otherDetail !== detail && otherDetail.hasAttribute("open")) {
            otherDetail.removeAttribute("open");
          }
        });
        
        const timeout = setTimeout(() => {
          this.setAttribute("open", "");
        }, 150);
        hoverTimeouts.set(this, timeout);
      });
      
      // MOUSELEAVE: Close dropdown after delay
      detail.addEventListener("mouseleave", function() {
        clearTimeout(hoverTimeouts.get(this));
        
        const timeout = setTimeout(() => {
          const isHoveringDetail = this.matches(":hover");
          const mainSubmenu = this.querySelector(".lirogo-submenu");
          const isHoveringSubmenu = mainSubmenu && mainSubmenu.matches(":hover");
          const hasOpenFlyouts = this.querySelector(".lirogo-submenu-parent[open]");
          
          if (!isHoveringDetail && !isHoveringSubmenu && !hasOpenFlyouts) {
            this.removeAttribute("open");
            // Close all nested flyouts when main dropdown closes
            const nestedFlyouts = this.querySelectorAll(".lirogo-submenu-parent[open]");
            nestedFlyouts.forEach(flyout => {
              flyout.removeAttribute("open");
            });
          }
        }, 400);
        hoverTimeouts.set(this, timeout);
      });
    });
    
    // Get ALL flyout details after classes have been assigned
    const flyoutDetails = document.querySelectorAll(".lirogo-submenu-parent");
    
    flyoutDetails.forEach(detail => {
      // MOUSEENTER: Open flyout
      detail.addEventListener("mouseenter", function() {
        clearTimeout(hoverTimeouts.get(this));
        
        // Close sibling flyouts at same level
        const parentLi = this.closest("li");
        if (parentLi) {
          const siblingLis = Array.from(parentLi.parentElement.children).filter(li => li !== parentLi);
          siblingLis.forEach(siblingLi => {
            const siblingDetail = siblingLi.querySelector(".lirogo-submenu-parent");
            if (siblingDetail && siblingDetail.hasAttribute("open")) {
              siblingDetail.removeAttribute("open");
            }
          });
        }
        
        const timeout = setTimeout(() => {
          this.setAttribute("open", "");
        }, 50);
        hoverTimeouts.set(this, timeout);
      });
      
      // MOUSELEAVE: Close flyout after delay
      detail.addEventListener("mouseleave", function() {
        clearTimeout(hoverTimeouts.get(this));
        
        const timeout = setTimeout(() => {
          const isHoveringDetail = this.matches(":hover");
          const flyoutSubmenu = this.querySelector(".lirogo-flyout-submenu");
          const isHoveringFlyout = flyoutSubmenu && flyoutSubmenu.matches(":hover");
          const hasOpenChildFlyouts = this.querySelector(".lirogo-submenu-parent[open]");
          
          if (!isHoveringDetail && !isHoveringFlyout && !hasOpenChildFlyouts) {
            this.removeAttribute("open");
            // Close all child flyouts when parent flyout closes
            const childFlyouts = this.querySelectorAll(".lirogo-submenu-parent[open]");
            childFlyouts.forEach(childFlyout => {
              childFlyout.removeAttribute("open");
            });
          }
        }, 300);
        hoverTimeouts.set(this, timeout);
      });
    });
  }
  
  function setupClosingBehavior() {
    document.addEventListener("click", function(event) {
      if (!event.target.closest(".header__inline-menu")) {
        const allDetails = document.querySelectorAll(".header__inline-menu details[open]");
        allDetails.forEach(detail => {
          detail.removeAttribute("open");
        });
        
        hoverTimeouts.forEach(timeout => clearTimeout(timeout));
        hoverTimeouts.clear();
      }
    });
  }

  if (window.innerWidth >= 750) {
    initializeHoverMenus();
    setTimeout(() => {
      initializeHoverMenus();
      const allDetails = document.querySelectorAll(".header__inline-menu details");
      const firstLevel = Array.from(allDetails).filter(detail => !detail.closest('.header__submenu')).length;
      const flyouts = document.querySelectorAll(".lirogo-submenu-parent").length;
      const mainNavItems = document.querySelectorAll(".header__inline-menu .header__menu-item:not(.header__submenu .header__menu-item)").length;
      const dropdownItems = document.querySelectorAll(".header__submenu .header__menu-item").length;
      console.log("lirogo Navigation: Found", firstLevel, "main dropdowns,", flyouts, "flyout menus,", mainNavItems, "main nav items,", dropdownItems, "dropdown items");
    }, 500);
  }
});
*/

document.addEventListener("DOMContentLoaded", function() {
  let hoverTimeouts = new Map();
  
  function initializeHoverMenus() {
    const submenus = document.querySelectorAll(".header__submenu.list-menu");
    submenus.forEach(submenu => {
      submenu.classList.add("lirogo-submenu");
    });
    
    // Main navigation items
    const mainNavItems = document.querySelectorAll(".header__inline-menu .header__menu-item:not(.header__submenu .header__menu-item)");
    mainNavItems.forEach(item => {
      item.classList.add("lirogo-nav-item");
    });
    
    // Dropdown/submenu items
    const dropdownItems = document.querySelectorAll(".header__submenu .header__menu-item");
    dropdownItems.forEach(item => {
      item.classList.add("lirogo-dropdown-item");
    });
    
    // Recursively find nested details elements
    function addFlyoutClasses(container, isFirstLevel = false) {
      const details = container.querySelectorAll("details");
      details.forEach(detail => {
        const hasSubmenu = detail.querySelector(".header__submenu");
        if (hasSubmenu) {
          if (!isFirstLevel) {
            detail.classList.add("lirogo-submenu-parent");
            hasSubmenu.classList.add("lirogo-flyout-submenu");
          }
          addFlyoutClasses(hasSubmenu, false);
        }
      });
    }
    
    const mainNav = document.querySelector(".header__inline-menu");
    if (mainNav) {
      addFlyoutClasses(mainNav, true);
    }
    
    setupHoverBehavior();
    setupClosingBehavior();
    setupParentDoubleClick(); // <-- NUEVO
  }
  
  function setupHoverBehavior() {
    const allDetails = document.querySelectorAll(".header__inline-menu details");
    const firstLevelDetails = Array.from(allDetails).filter(detail => !detail.closest('.header__submenu'));
    
    firstLevelDetails.forEach(detail => {
      detail.addEventListener("mouseenter", function() {
        clearTimeout(hoverTimeouts.get(this));
        firstLevelDetails.forEach(otherDetail => {
          if (otherDetail !== detail && otherDetail.hasAttribute("open")) {
            otherDetail.removeAttribute("open");
          }
        });
        const timeout = setTimeout(() => {
          this.setAttribute("open", "");
        }, 150);
        hoverTimeouts.set(this, timeout);
      });
      
      detail.addEventListener("mouseleave", function() {
        clearTimeout(hoverTimeouts.get(this));
        const timeout = setTimeout(() => {
          const isHoveringDetail = this.matches(":hover");
          const mainSubmenu = this.querySelector(".lirogo-submenu");
          const isHoveringSubmenu = mainSubmenu && mainSubmenu.matches(":hover");
          const hasOpenFlyouts = this.querySelector(".lirogo-submenu-parent[open]");
          
          if (!isHoveringDetail && !isHoveringSubmenu && !hasOpenFlyouts) {
            this.removeAttribute("open");
            const nestedFlyouts = this.querySelectorAll(".lirogo-submenu-parent[open]");
            nestedFlyouts.forEach(flyout => {
              flyout.removeAttribute("open");
            });
          }
        }, 400);
        hoverTimeouts.set(this, timeout);
      });
    });
    
    const flyoutDetails = document.querySelectorAll(".lirogo-submenu-parent");
    flyoutDetails.forEach(detail => {
      detail.addEventListener("mouseenter", function() {
        clearTimeout(hoverTimeouts.get(this));
        const parentLi = this.closest("li");
        if (parentLi) {
          const siblingLis = Array.from(parentLi.parentElement.children).filter(li => li !== parentLi);
          siblingLis.forEach(siblingLi => {
            const siblingDetail = siblingLi.querySelector(".lirogo-submenu-parent");
            if (siblingDetail && siblingDetail.hasAttribute("open")) {
              siblingDetail.removeAttribute("open");
            }
          });
        }
        const timeout = setTimeout(() => {
          this.setAttribute("open", "");
        }, 50);
        hoverTimeouts.set(this, timeout);
      });
      
      detail.addEventListener("mouseleave", function() {
        clearTimeout(hoverTimeouts.get(this));
        const timeout = setTimeout(() => {
          const isHoveringDetail = this.matches(":hover");
          const flyoutSubmenu = this.querySelector(".lirogo-flyout-submenu");
          const isHoveringFlyout = flyoutSubmenu && flyoutSubmenu.matches(":hover");
          const hasOpenChildFlyouts = this.querySelector(".lirogo-submenu-parent[open]");
          
          if (!isHoveringDetail && !isHoveringFlyout && !hasOpenChildFlyouts) {
            this.removeAttribute("open");
            const childFlyouts = this.querySelectorAll(".lirogo-submenu-parent[open]");
            childFlyouts.forEach(childFlyout => {
              childFlyout.removeAttribute("open");
            });
          }
        }, 300);
        hoverTimeouts.set(this, timeout);
      });
    });
  }
  
  function setupClosingBehavior() {
    document.addEventListener("click", function(event) {
      if (!event.target.closest(".header__inline-menu")) {
        const allDetails = document.querySelectorAll(".header__inline-menu details[open]");
        allDetails.forEach(detail => detail.removeAttribute("open"));
        hoverTimeouts.forEach(timeout => clearTimeout(timeout));
        hoverTimeouts.clear();
      }
    });
  }

  // --- NUEVO: doble clic para navegar al padre ---
  function setupParentDoubleClick() {
    const parentSummaries = document.querySelectorAll('.header__inline-menu > ul > li > header-menu > details > summary');

    parentSummaries.forEach(summary => {
      let clickTimer = null;
      const parentLink = summary.parentElement.dataset.url || summary.querySelector('a')?.href;

      summary.addEventListener('click', function(e) {
        if (!parentLink) return;

        if (clickTimer === null) {
          clickTimer = setTimeout(() => {
            clickTimer = null;
          }, 400); // ventana de doble clic
        } else {
          clearTimeout(clickTimer);
          clickTimer = null;
          window.location.href = parentLink;
        }
      });
    });
  }

  if (window.innerWidth >= 750) {
    initializeHoverMenus();
    setTimeout(() => {
      initializeHoverMenus();
      const allDetails = document.querySelectorAll(".header__inline-menu details");
      const firstLevel = Array.from(allDetails).filter(detail => !detail.closest('.header__submenu')).length;
      const flyouts = document.querySelectorAll(".lirogo-submenu-parent").length;
      const mainNavItems = document.querySelectorAll(".header__inline-menu .header__menu-item:not(.header__submenu .header__menu-item)").length;
      const dropdownItems = document.querySelectorAll(".header__submenu .header__menu-item").length;
      console.log("lirogo Navigation: Found", firstLevel, "main dropdowns,", flyouts, "flyout menus,", mainNavItems, "main nav items,", dropdownItems, "dropdown items");
    }, 500);
  }
});
